<template>
  <div class="content">
    <h1>About</h1>
    <div class="text-left px-4" v-html="compiledMarkdown" />
        <router-link class="border border-jpink mt-8 block py-2 px-4 mx-4 text-jpink hover:bg-jpink hover:text-white" :to="{name: 'basket'}">Order now</router-link>

  </div>
</template>


<script>
import marked from 'marked';
export default {
  computed: {
    compiledMarkdown: function () {
      return marked(this.$root.$data.images.about_content)
    }
  },
  head: {
    title() {
      return {
        inner: "About"
      }
    }
  }

}
</script>